import ApiClient from "../apiClient";

export type HoldenStatus = "draft" | "active" | "complete";

export interface RateCycle {
  id: string;
  nickname: string;
  startAt: string;
  endAt: string;
  previousDecisionAt: string | null;
  nextDecisionAt: string | null;
  anchorName: string;
  source: "economic_events" | "fallback";
}

export interface HoldenReflection {
  id: string;
  userId: string;
  cycleId: string;
  cycleNickname: string;
  title: string;
  mistake: string;
  whys: string[];
  solution: string;
  friction: string;
  smallWin: string;
  status: HoldenStatus;
  pnlSnapshot: number | null;
  deskPlanSnapshot: DeskPlanSnapshot | null;
  createdAt: string;
  updatedAt: string;
  completedAt: string | null;
}

export interface DeskPlanWindowSnapshot {
  id: string;
  title: string;
  time: string;
  startTime: string;
  endTime: string;
}

export interface DeskPlanSnapshot {
  date: string;
  title: string;
  theme: string;
  source: "day-plan";
  windows: DeskPlanWindowSnapshot[];
  summary: string;
  attachedAt: string;
}

export interface HoldenReflectionInput {
  title?: string;
  mistake?: string;
  whys?: string[];
  solution?: string;
  friction?: string;
  smallWin?: string;
  status?: HoldenStatus;
  pnlSnapshot?: number | null;
  deskPlanSnapshot?: DeskPlanSnapshot | null;
}

export interface TradeDeveloperState {
  feature: "TradeDeveloper";
  method: "Holden Method";
  cycle: RateCycle;
  activeReflection: HoldenReflection | null;
  recentReflections: HoldenReflection[];
  productLoop: {
    trigger: string;
    action: string;
    reward: string;
    investment: string;
  };
}

export class TradeDeveloperService {
  constructor(private client: ApiClient) {}

  async getCurrent(): Promise<TradeDeveloperState> {
    return this.client.get("/api/trade-developer/current");
  }

  async start(): Promise<{
    reflection: HoldenReflection;
    state: TradeDeveloperState;
  }> {
    return this.client.post("/api/trade-developer/start", {});
  }

  async saveReflection(
    input: HoldenReflectionInput,
  ): Promise<{ reflection: HoldenReflection }> {
    return this.client.post("/api/trade-developer/reflections", input);
  }

  async updateReflection(
    id: string,
    input: HoldenReflectionInput,
  ): Promise<{ reflection: HoldenReflection }> {
    return this.client.patch(`/api/trade-developer/reflections/${id}`, input);
  }
}
